module.exports = __webpack_public_path__ + "img/辉煌武技.0abf2371.webp";